import React from 'react';


const MyMessage= ({message}) => {

    //find message actual text or image
    if(message?.attachment?.length>0){

        return(
            <img
                src={message.attachment[0].file}
                alt="message-attachment"
                className="message-image"
                style={{float:'right'}}
            />
        )
    }
    return(
        //render text
        <div className="message" style={{float:'right' , marginRight : '18px' ,color : 'white',backgroundColor:"#3B2A50"}}>
         {message.text}
        </div>
    )
}

export default MyMessage;